// const splide = new Splide( '.custom_marqueeMain', {
//   type   : 'loop',
//   drag   : 'free',
//   focus  : 'center',
//   arrows: false,
//   pagination: false,
//   perPage: 2,
//   autoScroll: {
//     speed: 1,
//   },
// } );
// splide.mount();

const marqueElement = document.querySelector('.custom_marqueeMain');
const marque = new Splide(marqueElement, {
  type: 'loop',
  drag: 'free',
  focus: 'center',
  arrows: false,
  pagination: false,
  perPage: 2,
  autoWidth: true,
  autoScroll: {
    speed: 1.2,
    pauseOnHover  : false,  // 👈 disables pause on hover
    pauseOnFocus  : false,  // 👈 disables pause on focus
  },
  breakpoints: {
    767: {
      perPage: 2,
    }
  },
});
marque.mount(window.splide.Extensions);